
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import { BLoadingComponent } from 'buefy/types/components';

import PasswordField from '../../../../framework/fields/PasswordField.vue';

import { sharedState } from '../../../../framework/state';

import { errorToast, successToast } from '../../../service/toast_service';

@Component({
    components: { PasswordField, ValidationProvider },
})
export default class SaveApiKey extends Vue {
    @Prop(String) readonly customerId!: string;
    @Prop(String) readonly label!: string;
    @Prop(String) readonly toastKey!: string;
    @Prop(Number) readonly minLength!: number;
    @Prop(Function) readonly saveApiKey!: (customerId: string, apiKey: string) => Promise<{ success: number }>;
    @Prop(Function) readonly getApiKey!: (customerId: string) => Promise<{ apiKey: string }>;

    // Properties

    // State
    shared = sharedState;
    local = {
        apiKey: '',
        loadingComponent: {} as BLoadingComponent,
    };

    // Functions
    async mounted() {
        await this.loadAsyncData();
    }

    async loadAsyncData() {
        this.showLoading();
        this.local.apiKey = (await this.getApiKey(this.customerId)).apiKey;
        this.hideLoading();
    }

    async onSaveApiKeyClick() {
        this.showLoading();
        try {
            const result = await this.saveApiKey(this.customerId, this.local.apiKey);
            successToast(this, this.toastKey, [result.success]);
            this.hideLoading();
            await this.loadAsyncData();
        } catch (error) {
            errorToast(this);
            this.hideLoading();
        }
    }

    private showLoading(): void {
        this.local.loadingComponent = this.$buefy.loading.open({});
    }

    private hideLoading(): void {
        this.local.loadingComponent.close();
    }
}
